import React, { useState } from "react";
import { Table, Progress } from "antd";
import newStyled from "@emotion/styled";
import { DownOutlined, UpOutlined } from "@ant-design/icons";
import useScoreScale from "../../../../utils/hooks/useScoreScale";

const ScoreProgress = ({ score, colorScale }) => {
  const scoreConfig = useScoreScale(score, colorScale);

  return (
    <ScoreContainer>
      <span
        style={{
          width: "100%",
          maxWidth: "8%",
          padding: "6px 0px",
        }}
      >
        {score}%
      </span>

      <ProgressStyleForTable
        percent={score}
        size="small"
        strokeColor={scoreConfig.bgColor}
        showInfo={false}
      />
    </ScoreContainer>
  );
};

const ARSection = ({ data, primaryColor, colorScale }) => {
  const [isARSectionOpen, setIsARSectionOpen] = useState(true);

  const filteredData = data.filter(
    (item) => item.maxMarks !== 0 && item.maxMarks !== null,
  );

  const columns = [
    {
      title: "S. No.",
      dataIndex: "key",
      key: "key",
      align: "center",
      width: 10,
    },
    {
      title: "Section",
      dataIndex: "section",
      key: "section",
      align: "left",
      width: 1500,
    },
    {
      title: "Score",
      dataIndex: "score",
      key: "score",
      align: "center",
      width: 3000,
      render: (score) => (
        <ScoreProgress score={score} colorScale={colorScale} />
      ),
    },
  ];

  return (
    filteredData.length > 0 && (
      <div className="card">
        <div
          className="card-header"
          onClick={() => setIsARSectionOpen((prev) => !prev)}
          style={{
            backgroundColor: primaryColor || undefined,
            color: primaryColor ? "#fff" : undefined,
          }}
        >
          <p>Report Sections</p>
          {!isARSectionOpen ? <UpOutlined /> : <DownOutlined />}
        </div>
        {isARSectionOpen && (
          <div className="p-2">
            <p className="head-queSecHead p-2 m-0">Audit Summary</p>
            <TableStl
              columns={columns}
              dataSource={filteredData}
              pagination={false}
              bordered
              scroll={{ x: 550 }}
            />
          </div>
        )}
      </div>
    )
  );
};

const TableStl = newStyled(Table)`
:where(.css-dev-only-do-not-override-1kf000u).ant-table-wrapper .ant-table-cell{
padding:px !important;
}
    
:where(.css-dev-only-do-not-override-1kf000u).ant-table-wrapper .ant-table-thead >tr>th{
background-color: rgb(242,242,242);
font-weight:500px;
font-family:'Roboto', sans-serif;
}
`;
const ScoreContainer = newStyled.div`
  display: flex !important;
  flex-direction: row;
  gap: 4px !important;
`;

const ProgressStyleForTable = newStyled(Progress)`
:where(.css-dev-only-do-not-override-1kf000u).ant-progress {
 padding: 6px 0px !important;
}`;

export default ARSection;
